import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField, 
  List, 
  ListItemButton,
  ListItemText,
  IconButton 
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const PresetDialogs = ({
  presetDialogOpen,
  setPresetDialogOpen,
  presetName,
  setPresetName,
  loadPresetDialogOpen,
  setLoadPresetDialogOpen,
  savePreset,
  loadPreset,
  deletePreset,
  presets,
  updateFunctions,
  className = ""
}) => {
  return (
    <div className={`preset-dialogs ${className}`}>
      {/* Save preset dialog */}
      <Dialog 
        className="preset-dialogs-save"
        open={presetDialogOpen} 
        onClose={() => setPresetDialogOpen(false)}
      >
        <DialogTitle className="preset-dialogs-save-title">Save Pattern Preset</DialogTitle>
        <DialogContent className="preset-dialogs-save-content">
          <TextField 
            className="preset-dialogs-save-input"
            label="Preset Name" 
            value={presetName} 
            onChange={(e) => setPresetName(e.target.value)} 
            fullWidth
          />
        </DialogContent>
        <DialogActions className="preset-dialogs-save-actions">
          <Button 
            className="preset-dialogs-save-button cancel"
            onClick={() => setPresetDialogOpen(false)}
          >
            Cancel
          </Button>
          <Button 
            className="preset-dialogs-save-button save"
            onClick={() => savePreset()}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Load preset dialog */}
      <Dialog 
        className="preset-dialogs-load"
        open={loadPresetDialogOpen} 
        onClose={() => setLoadPresetDialogOpen(false)}
      >
        <DialogTitle className="preset-dialogs-load-title">Load Pattern Preset</DialogTitle>
        <DialogContent className="preset-dialogs-load-content">
          <List className="preset-dialogs-load-list">
            {Object.keys(presets).map((name) => (
              <ListItemButton
                className="preset-dialogs-load-item"
                key={name}
                onClick={() => loadPreset(name, updateFunctions)}
              >
                <ListItemText 
                  className="preset-dialogs-load-item-text"
                  primary={name} 
                />
                <IconButton 
                  className="preset-dialogs-load-item-delete"
                  edge="end" 
                  aria-label="delete" 
                  onClick={(e) => {
                    e.stopPropagation();
                    deletePreset(name);
                  }}
                >
                  <DeleteIcon className="preset-dialogs-load-item-delete-icon" />
                </IconButton>
              </ListItemButton>
            ))}
          </List>
        </DialogContent>
        <DialogActions className="preset-dialogs-load-actions">
          <Button 
            className="preset-dialogs-load-button cancel"
            onClick={() => setLoadPresetDialogOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PresetDialogs;
